module.exports = "pegasus/assets/theme4/header-image.jpg";